import type { TOC } from '@ember/component/template-only';
import { t } from 'ember-intl';
import SettingsPageTemplate from 'lumen/components/settings/page-template';

const MarketSettingsCost: TOC<{ Args: object }> = <template>
  <SettingsPageTemplate
    @description={{t "settings.cost.page_description"}}
    @title={{t "settings.cost.title"}}
    @type="container"
  />
</template>;

export default MarketSettingsCost;
